<template>
    <div class="language-switcher" v-click-outside-element="close" v-if="show">
        <div class="language-switcher__dropdown" v-show="isOpen">
            <a
                v-for="language in languages"
                :key="language.code"
                :href="language.url"
                :class="{ 'language-switcher__item--active': language.code === currentLanguage }"
                class="language-switcher__item">
                <img :src="language.flag" alt="flag" v-if="language.flag" />
                {{ language.name }}
            </a>
        </div>

        <div class="language-switcher__button" @click="isOpen = !isOpen">
            <img src="https://images.iphonephotographyschool.com/35849/Frame-503.svg" alt="globe" />
            <img src="https://images.iphonephotographyschool.com/35846/Vector-1.svg" alt="chevron" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import translations from '../locales/constants/translations';
import languageNames from '../locales/constants/names';
import flags from '../locales/constants/flags';

export default {
    data() {
        return {
            languages: [],
            isOpen: false,
        };
    },
    computed: {
        ...mapGetters(['product']),
        currentLanguage() {
            // Use the reactive language from the plugin if available, fallback to window.App
            return this.$currentLanguage?.value || window.App.language;
        },
        show() {
            return this.languages.length > 1 || this.isCrowdin;
        },
    },
    methods: {
        setLanguages() {
            const userLanguage = window.navigator.language || window.navigator.userLanguage;
            const userLanguageCode = userLanguage.toLowerCase();
            const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);

            locales.keys().forEach((key) => {
                const matched = key.match(/([A-Za-z0-9-_]+)\./i);

                if (matched && matched.length > 1) {
                    const locale = matched[1];
                    const isTranslated =
                        translations[locale]?.includes(this.product.progress_tracking_slug) ||
                        translations[locale]?.includes('*') ||
                        this.isCrowdin;
                    const flagMatch = userLanguageCode.includes(locale);

                    if (!isTranslated) return;

                    this.languages.push({
                        code: locale,
                        name: languageNames[locale],
                        url: this.generateURL(locale),
                        flag: flagMatch ? flags[userLanguageCode] || flags[locale] : flags[locale] || flags[locale],
                    });
                }
            });
        },
        generateURL(language) {
            const url = new URL(window.location.href);

            url.searchParams.set('lang', language);

            if (!url.searchParams.get('switch-lang')) {
                url.href += '&switch-lang=1';
            }

            return url.href;
        },
        close() {
            if (!this.isOpen) return;

            this.$nextTick(() => {
                this.isOpen = false;
            });
        },
    },
    mounted() {
        this.setLanguages();
    },
};
</script>

<style lang="sass" scoped>
.language-switcher
    position: fixed
    bottom: 75px
    right: 20px
    z-index: 8
    transition: bottom 0.2s ease-in-out

    @media screen and (max-width: 776px)
        bottom: 20px

    &.floating-buy-button-active
        bottom: 135px

        @media screen and (max-width: 776px)
            bottom: 80px

    &__button
        display: flex
        align-items: center
        gap: 10px
        padding: 12px
        border: 1px solid #000
        border-radius: 12px
        background: #fff
        cursor: pointer

        span
            font-size: 13px
            font-weight: 600
            text-transform: uppercase

    &__dropdown
        position: absolute
        bottom: 62px
        right: 0
        padding: 3px
        border: 1px solid #000
        border-radius: 8px
        background: #fff

    &__item
        display: flex
        align-items: center
        gap: 8px
        position: relative
        font-size: 13px
        line-height: 30px
        padding: 0 8px
        color: #000
        border-radius: 4px

        &--active
            color: #fff
            background: #4498F7

            &:hover
                text-decoration: none

        img
            min-width: 18px
            max-width: 18px
</style>
